<mat-tab-group #tabGroup (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="Квартиры">
        <div class="apartment-content" *ngIf="loadedTabs.has(RoomTypeEnum.Flats)">
            <div class="apartment-scheme">
                <div class="table-body" *ngIf="spotObject?.floors > 0">

                    <div class="typical-btn btn btn-apply" (click)="openTypicalFloor.emit()">
                        Типовые этажи
                    </div>
                    <table>
                        <thead>
                        <tr>
                            <th>Квартир</th>
                            <th>Площадь</th>
                            <th>Этаж</th>
                            <th
                                    attr.colspan="{{spotObject?.apartmentScheme?.length > 0 ? spotObject?.apartmentScheme[0].length : 6}}">
                                <span>Пятно {{ spotObject?.number }} / Д {{ spotObject.homeNumber }} / </span>
                                <span>Квартир {{ spotObject.apartment_number }}</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let floor of obj; let i = index">
                            <th>{{ floor?.flatCount ?? '-' }}</th>
                            <th>{{ (floor.flatArea| numberWithSpaces) ?? '-' }}</th>
                            <th>{{ floor.floorID ?? '-' }}</th>
                            <ng-container *ngFor="let flat of floor.flatsArr">
                                <ng-container *ngFor="let f of flat.info; let index = index">
                                    <td (click)="f.flatConfigurationID ? chooseFlat(f) : null" class="flat-box">
                                        <div class="flat-box__inner"
                                             [ngClass]="{'green': f.isSale, 'cursor': f.flatConfigurationID}">
                                            <div class="hover-text" *ngIf="f.isCornerFlat">Угловая квартира</div>
                                            <div class="triangle" *ngIf="f.isCornerFlat"></div>
                                            <span class="room">{{ f.roomCountID || '-' }}{{ f.roomCountID ? ' ком.' : '' }}</span>
                                            <span>{{ f.flatNumber ? '№' + f.flatNumber : '-' }}</span>
                                            <span class="room">{{ f.flatArea | numberWithSpaces }}{{ f.flatArea ? ' кв.м.' : '' }}</span>
                                            <span class="item-close"
                                                  *ngIf="f.roomCountID && !f.isSale"
                                                  (click)="onDeleteFlat(spotObject.id, floor.floorID, f.roomCountID, flat.info, index, f.flatID); $event.stopPropagation();"></span>
                                        </div>
                                    </td>
                                </ng-container>
                            </ng-container>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Коммерческие помещения">
        <div class="apartment-content" *ngIf="loadedTabs.has(RoomTypeEnum.Commercial)">
            <app-commercial-rooms
                    [reloadTrigger]="reloadTrigger"
                    [buildingNumber]="spotObject.number"
                    [houseNumber]="spotObject.homeNumber"
                    [buildingID]="spotObject.id"
                    [roomTypeID]="RoomTypeEnum.Commercial">
            </app-commercial-rooms>
        </div>
    </mat-tab>
    <mat-tab label="Паркоместа">
        <div class="apartment-content" *ngIf="loadedTabs.has(RoomTypeEnum.Parking)">
            <app-commercial-rooms
                    [reloadTrigger]="reloadTrigger"
                    [buildingNumber]="spotObject.number"
                    [houseNumber]="spotObject.homeNumber"
                    [buildingID]="spotObject.id"
                    [roomTypeID]="RoomTypeEnum.Parking">
            </app-commercial-rooms>
        </div>
    </mat-tab>
</mat-tab-group>

